import { UPDATE_SEARCHTDATA_TAISAN } from "actions/DanhSachTaiSan/actionTypes";

const initialState = {
  mataisan:"",
  tentaisan: "",
  tenkhachhang: "",
  kho: 0,
  trangthai: -1,
  tinhtrang: 0,
  ghichu: "",
  pageIndex: 1,
  pageSize: 20,
};

const updateDataSearch = (state, action) => ({
  ...action.payload,

  //matentaisan: action.payload.matentaisan,
  //searchText: action.payload,
});

export const dataSearchTaiSan = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_TAISAN:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchTaiSan;
